/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */
import axios from 'axios';

const request = ({ endpoint, method = 'GET', ...props }) => {
  const userIdentity = JSON.parse(sessionStorage.getItem('userIdentity'));
  return axios({
    method,
    url: `${process.env.REACT_APP_HOST_URL}${endpoint}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${userIdentity.token}`,
    },
    responseType: 'json',
    ...props,
  }).then((res) => res.data);
};

export const getCampaign = (id) => request({
  endpoint: `Campaign/${id}`,
}); 

export const getCampaigns = (parameters) => request({
  endpoint: `Campaign${parameters}`,
});

export const getMarkets = (id, parameters) => request({
  endpoint: `Campaign/${id}/markets${parameters}`,
});

export const getCampaignsCreate = () => request({
  endpoint: 'Campaign/create',
});

export const addCampaign = (data) => request({
  endpoint: 'Campaign/store',
  method: 'POST',
  data,
});

export const updateCampaign = (data, id) => request({
  endpoint: `Campaign/${id}`,
  method: 'PUT',
  data,
});

export const getGroupName = (id, scopeId) => request({
  endpoint: `ClientGroup?CampaignType=${id}&OrganisationScopeId=${scopeId}`,
});

export const getExistingGroupNameMarkets = (id) => request({
  endpoint: `Campaign/${id}/market-distributions`,
});

export const getGroupNameMarketsAndStations = (groupNameId, campaignId, scopeId) => request({
  endpoint: `ClientGroup/${groupNameId}?CampaignId=${campaignId}&OrganisationScopeId=${scopeId}`,
})

export const getGroupNameMarkets = ({groupNameId, data}) => request({
  endpoint: `ClientGroup/${groupNameId}/markets`,
  method: 'POST',
  data
})

export const saveOrApplyMarkets = ({groupNameId, data}) => request({
  endpoint: `ClientGroup/${groupNameId}/apply-markets`,
  method: 'POST',
  data
})

export const getMarketStations = ({campaignId, data}) => request({
  endpoint: `ClientGroup/${campaignId}/markets-stations`,
  method: 'POST',
  data
})

export const saveOrApplyMarketStations = ({data}) => request({
  endpoint: `ClientGroup/apply-market-stations`,
  method: 'POST',
  data
})

export const notifyStations = (data, id) => request({
  endpoint: `Campaign/${id}/notify-stations`,
  method: 'POST',
  data,
});

export const updateMarketDistribution = (data, id) => request({
  endpoint: `Campaign/${id}/market-distribution`,
  method: 'PUT',
  data,
});
export const updateWeeklyDistribution = (data, id) => request({
  endpoint: `Campaign/${id}/weekly-distribution`,
  method: 'PUT',
  data,
});

export const updateBookedCampaign = (id) => request({
  endpoint: `Campaign/${id}/booked`,
  method: 'PUT'
});

export const getMarketRollupHeaders = (campaignId, marketId) => request({
  endpoint: `Campaign/getMarketRollupHeaders?campaignId=${campaignId}&marketId=${marketId}`,
  method: 'GET'
});

export const getCampaignRollupHeaders = (campaignId) => request({
  endpoint: `Campaign/getCampaignRollupHeaders/${campaignId}`,
  method: 'GET'
});

export const checkBookingGenerationStatus = (campaignId, marketId) => request({
  endpoint: `Campaign/${campaignId}/bookings/${marketId}/status`,
  method: 'GET'
});

export const getMarketsStationNotification = (campaignId, filterStationsWithoutAvails = false) => request({
  endpoint: `Campaign/${campaignId}/markets-stations-notification`,
  method: 'GET',
  params: {
    filterStationsWithoutAvails,
  },
});

export const getMarketStationsNotification = (campaignId, marketId) => request({
  endpoint: `Campaign/${campaignId}/markets-stations-notification/${marketId}`,
  method: 'GET'
});

export const saveEmailTemplate = (data) => request({
  endpoint: `Campaign/email-templates`,
  method: 'POST',
  data,
});

export const getEmailTemplates = () => request({
  endpoint: `Campaign/email-templates`,
  method: 'GET'
});

export const updateEmailTemplate = (id, data) => request({
  endpoint: `Campaign/email-templates/${id}`,
  method: 'PUT',
  data,
});

export const deleteEmailTemplate = (id) => request({
  endpoint: `Campaign/email-templates/${id}`,
  method: 'DELETE'
});

export const sendTestEmail = (id, data) => request({
  endpoint: `Campaign/email-templates/${id}/test-email`,
  method: 'POST',
  data,
});

export const sendEmailToStations = (id, data) => request({
  endpoint: `Campaign/email-templates/${id}/notify-station`,
  method: 'POST',
  data,
});

export const saveSpendByDayAndWeek = (id, data) => request({
  endpoint: `Campaign/${id}/parameters-distribution`,
  method: 'POST',
  data,
});

export const processMarketBookings = (id) => request({
  endpoint: `campaign/${id}/bookings/optimiseall`,
  method: 'GET',
});

export const updateAllRollup = (id) => request({
  endpoint: `campaign/${id}/updateallrollups`,
  method: 'PUT',
});

export const getCampaignActiveStationCount = (id) => request({
  endpoint: `Campaign/${id}/get-active-station-count`,
  method: 'GET',
});

export const downloadCampaignSchedules = (id) => {
  const userIdentity = JSON.parse(sessionStorage.getItem('userIdentity'));

  return request({
    endpoint: `Campaign/download-schedules/${id}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/xml',
      Accept: 'application/xml',
      Authorization: `Bearer ${userIdentity.token}`,
    },
    responseType: 'arrayBuffer',
  });
};

export const getCampaignMarketsNotification = (id) => {
  return request({
    endpoint: `campaign/${id}/campaign-markets-notification`,
    method: 'GET',
  });
};

export const finalizeCampaignLevelSchedule = async (campaignId) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const avails = await request({
      endpoint: `Campaign/${campaignId}/bookings/finalize-campaign-level`,
      method: 'PATCH',
      headers: {},
    });
    return avails;
  } catch (error) {
    throw error;
  }
};

export const checkExistingStationOrders = (id) => {
  try {
    const response = request({
      endpoint: `Campaign/${id}/check-existing-station-orders`,
      method: 'GET',
    });

    return response;
  } catch (error) {
    throw error;
  }
};